import scrollIntoView from 'scroll-into-view';

export const scrollIntoSellerModule = ({
    primaryContainerBottomRef,
}: {
    primaryContainerBottomRef: React.RefObject<HTMLDivElement | null>;
}): void => {
    const primaryContainerBottomRefEl = primaryContainerBottomRef?.current;

    if (primaryContainerBottomRefEl) {
        scrollIntoView(
            primaryContainerBottomRefEl,
            { time: 500, align: { top: 0, topOffset: -300 } },
            primaryContainerBottomRefEl.focus()
        );
    }
};
